module.exports = __webpack_public_path__ + "logo_booking-4b9ff0ca75aa2ca35c3974373743679b.png";


//////////////////
// WEBPACK FOOTER
// ./assets/logo_booking.png
// module id = 1375
// module chunks = 1